var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.33333,
    height: 30.6315,
    transform: "matrix(0 -1 -1 0 31.5216 25)",
    fill: "#D5D5D5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 6.80699,
    transform: "matrix(0 -1 -1 0 23.0128 20)",
    fill: "#D5D5D5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 11.9122,
    transform: "matrix(0 -1 -1 0 12.8025 20)",
    fill: "#D5D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowdown);
export default __webpack_public_path__ + "static/media/icon _arrow down.3bfbf6f4f2f4a946d52cda6fcb930477.svg";
export { ForwardRef as ReactComponent };